import { NavLink } from "react-router-dom";
import { NAV_ITEMS } from "@/lib/nav";
import { Logo } from "@/components/Logo";
import { cn } from "@/lib/utils";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

export function Sidebar({ onNavigate }) {
  const { user } = useAuth();
  const perms = user?.permissions || [];
  const items = NAV_ITEMS.filter((i) => perms.includes(i.perm));

  return (
    <aside className="flex h-full w-64 flex-col border-r border-border bg-card" data-testid="sidebar">
      <div className="flex h-16 items-center border-b border-border px-5">
        <Logo />
      </div>
      <nav className="flex-1 space-y-0.5 overflow-y-auto px-3 py-4">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={onNavigate}
              data-testid={`nav-${item.to.replace("/", "")}`}
              className={({ isActive }) =>
                cn(
                  "group flex items-center justify-between rounded-lg px-3 py-2.5 text-sm font-medium transition-colors",
                  isActive
                    ? "bg-primary/10 text-primary"
                    : "text-muted-foreground hover:bg-accent hover:text-foreground"
                )
              }
            >
              <span className="flex items-center gap-3">
                <Icon className="h-[18px] w-[18px]" strokeWidth={2} />
                {item.label}
              </span>
              {!item.active && (
                <Lock className="h-3.5 w-3.5 opacity-40" strokeWidth={2} />
              )}
            </NavLink>
          );
        })}
      </nav>
      <div className="border-t border-border p-4">
        <p className="text-xs text-muted-foreground">Connectivity · Fase 1</p>
      </div>
    </aside>
  );
}
